import { ERROR_CODE } from '@/constants/api';

import { PEPQuestion, QuestionCode } from '@/types/api/pep';
import { User } from '@/types/user';

import { getAPIDataError } from './api';

type AnsweredPersonalAccountArgs = {
  user?: User;
  pepQuestions?: PEPQuestion[];
  enabledRightStartAccount?: boolean;
};

export function answeredPersonalAccount({
  user,
  pepQuestions,
}: AnsweredPersonalAccountArgs) {
  const { pepAnswered = [], lastAnswer } = user || {};
  const isAnswered = pepAnswered?.some(
    qCode => qCode === QuestionCode.Personal,
  );

  const pepQuestion = pepQuestions?.find(
    pepQuestion => pepQuestion.code === QuestionCode.Personal,
  );

  const isPositive = lastAnswer?.answers?.some(question => {
    const isPersonalQuestion =
      (question.code && question.code === QuestionCode.Personal) ||
      (pepQuestion && question.questionId === pepQuestion.id);

    if (isPersonalQuestion) {
      const answer = question.positive;
      const green = question.green;
      if (green) {
        return answer;
      }
      return !answer;
    }
    return false;
  });

  return {
    isAnswered,
    isPassed: isAnswered && isPositive,
  };
}

export function isThirdPartyComplianceError(error?: unknown): boolean {
  const errorData = getAPIDataError<{ error?: string }>(error);
  return errorData?.error === ERROR_CODE.THIRD_PARTY_COMPLIANCE_PEP_YES;
}
